var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { makeStyles, Chip } from "@material-ui/core";
import React from "react";
import CloseIcon from "../icons/Close";
export const useStyles = makeStyles((theme) => ({
    root: {
        position: "relative",
        zIndex: 1300,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        maxHeight: 20,
        maxWidth: 200,
        padding: 0,
        borderRadius: 4,
        margin: 4,
    },
    label: Object.assign(Object.assign({}, theme.typography.tooltip), { color: theme.palette.text.secondary, height: 16, margin: "2px 4px", padding: 0 }),
    deleteIcon: {
        width: 20,
        height: 20,
        margin: 0,
        borderRadius: "0px 4px 4px 0px",
        fill: theme.palette.icon.secondary,
        "&:hover": {
            backgroundColor: "#FEB5A4",
        },
    },
}));
export default (_a) => {
    var otherProps = __rest(_a, []);
    const classes = useStyles();
    return (React.createElement(Chip, Object.assign({}, otherProps, { deleteIcon: React.createElement(CloseIcon, { size: "small" }), classes: Object.assign({}, classes) })));
};
//# sourceMappingURL=FTLChip.js.map